/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Placements_Vibebids_Feature_DescriptionInputs */

const en_directory_promotion_placements_vibebids_feature_description = /** @type {(inputs: Directory_Promotion_Placements_Vibebids_Feature_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a clear sponsored placement above the standard VibeBids board.`)
};

const zh_directory_promotion_placements_vibebids_feature_description = /** @type {(inputs: Directory_Promotion_Placements_Vibebids_Feature_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在标准 VibeBids 榜单上方展示明确的赞助推广位。`)
};

/**
* | output |
* | --- |
* | "Add a clear sponsored placement above the standard VibeBids board." |
*
* @param {Directory_Promotion_Placements_Vibebids_Feature_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_placements_vibebids_feature_description = /** @type {((inputs?: Directory_Promotion_Placements_Vibebids_Feature_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Placements_Vibebids_Feature_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_placements_vibebids_feature_description(inputs)
	return zh_directory_promotion_placements_vibebids_feature_description(inputs)
});
export { directory_promotion_placements_vibebids_feature_description as "directory.promotion.placements.vibebids-feature.description" }